import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage, FormattedDate, FormattedTime } from 'react-intl';
import get from 'lodash/get';
import Header from '../../components/Header';
import messages from './messages';
import Avatar from '../../components/Avatar';
import Grid from '../../components/Grid';
import Contact from './event-contact';
import { getAddress } from '../ContactsContainer/util';
import { getDate } from '../AvailabilityCalendar/date-utils';
import FeatureEnabled from '../../components/FeatureEnabled';
import SubscriptionActive from '../../components/SubscriptionActive';
import { REPVISITS_LOOKING_FOR_YOU_COUNT, REP_VISITS_SUBSCRIPTION } from '../Authorization/constants';
import './styles.css';

const EventDetails = ({ type, highSchool, eventDetails, isVirtualEvent }) => {
  const { contact, phone, instructions, title, timezone, cost, expectedStudents, startISOTime, endISOTime, date } = eventDetails;
  const highSchoolName = get(highSchool, 'name');
  const highSchoolAddress = getAddress(get(highSchool, 'address'));
  const interestedStudents = get(highSchool, 'interestedStudents', 0);
  const start = getDate(date, startISOTime);
  const end = getDate(date, endISOTime);
  const virtualMessageDetails = isVirtualEvent ? messages.virtualVisitDetails : messages.inPersonVisitDetails;
  return (
    <div styleName="event-details">
      <Header as="h1" styleName="header-text">
        {title}
      </Header>
      <Header as="h2" styleName="section-title" size="small" data-cy="repvisits-calendar-event-detail-title">
        {type === 'fair' && <FormattedMessage {...messages.fairDetails} />}
        {type !== 'fair' && (
          <React.Fragment>
            <FormattedMessage {...virtualMessageDetails} />
          </React.Fragment>
        )}
      </Header>
      <Grid>
        <Grid.Row>
          <Grid.Column>
            <h5 styleName="detail-label">
              <FormattedMessage {...messages.contact} />
            </h5>
            <Contact contact={contact} phone={phone} />
          </Grid.Column>
        </Grid.Row>
        <Grid.Row>
          <Grid.Column>
            <h5 styleName="detail-label">
              <FormattedMessage {...messages.school} />
            </h5>
            <div styleName="school-container">
              <Avatar small icon="university" />
              <div styleName="school-name">
                {highSchoolName}
              </div>
              <div styleName="address">
                {highSchoolAddress}
              </div>
              <FeatureEnabled allOf={REPVISITS_LOOKING_FOR_YOU_COUNT}>
                <SubscriptionActive anyOf={[REP_VISITS_SUBSCRIPTION]}>
                  <div styleName="interested-students-line">
                    <FormattedMessage {...messages.interestedStudents} /> : {interestedStudents < 10 ? ('N/A') : (
                      <div styleName="interested-students">
                        <span>{interestedStudents}</span>
                      </div>
                    )}
                  </div>
                </SubscriptionActive>
              </FeatureEnabled>
            </div>
          </Grid.Column>
        </Grid.Row>
        <Grid.Row>
          <Grid.Column width={8} size="small">
            <h5 styleName="detail-label">
              <FormattedMessage {...messages.date} />
            </h5>
            <div data-cy="repvisits-calendar-event-detail-date">
              <FormattedDate
                value={start}
                weekday="long"
                month="long"
                day="numeric"
                year="numeric"
              />
            </div>
          </Grid.Column>
          <Grid.Column width={8} size="small">
            <h5 styleName="detail-label">
              <FormattedMessage {...messages.time} />
            </h5>
            <div>
              <FormattedTime value={start} />-<FormattedTime value={end} /> <span> ({timezone})</span>
            </div>
          </Grid.Column>
        </Grid.Row>
        {type === 'fair' && (
          <Grid.Row>
            <Grid.Column width={8} size="small">
              <FormattedMessage {...messages.cost} />
              <div>
                {cost}
              </div>
            </Grid.Column>
            <Grid.Column width={8} size="small">
              <FormattedMessage {...messages.expectedstudents} />
              <div>
                {expectedStudents}
              </div>
            </Grid.Column>
          </Grid.Row>
        )}
        <Grid.Row>
          <Grid.Column>
            <h5 styleName="detail-label">
              <FormattedMessage {...messages.instructions} />
            </h5>
            <div>
              {instructions}
            </div>
          </Grid.Column>
        </Grid.Row>
      </Grid>
    </div>
  );
};

EventDetails.propTypes = {
  type: PropTypes.string.isRequired,
  highSchool: PropTypes.object.isRequired,
  eventDetails: PropTypes.object.isRequired,
  isVirtualEvent: PropTypes.bool,
};

export default EventDetails;
